var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnfoldMore(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "unfold_more"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_552_363",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_552_363)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "unfold_more_2",
    d: "M8 14L5 11L5.96667 10.0334L8 12.0667L10.0333 10.0334L11 11L8 14ZM5.96667 6.03338L5 5.06671L8 2.06671L11 5.06671L10.0333 6.03338L8 4.00004L5.96667 6.03338Z",
    fill: "#777777"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnfoldMore);
export default __webpack_public_path__ + "static/media/unfold_more.844e840133a3c03d8a7866685123db5b.svg";
export { ForwardRef as ReactComponent };